<top-bar-tabs></top-bar-tabs>
<div class="container">
  <div class="filters">
    <deal-search [control]="taskFilters.controls.project_id"></deal-search>
    <mat-form-field>
      <mat-label>Sort</mat-label>
      <mat-select [formControl]="taskFilters.controls.order">
        <mat-option>Default</mat-option>
        <mat-option [value]="{ column: 'DUE_DATE', order: 'DESC' }"
          >Due Date
        </mat-option>
        <mat-option [value]="{ column: 'TIMING_DATE', order: 'DESC' }"
          >Request Timing
        </mat-option>
        <mat-option [value]="{ column: 'RECEIVED_DATE', order: 'DESC' }"
          >Request Received
        </mat-option>
        <mat-option [value]="{ column: 'STARTED', order: 'ASC' }"
          >Started
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Request Timing</mat-label>
      <input
        matInput
        [formControl]="taskFilters.controls.timing_date"
        [matDatepicker]="picker" />
      <mat-datepicker-toggle
        matIconSuffix
      [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Request Status</mat-label>
      <mat-select [formControl]="taskFilters.controls.request_status_id">
        <mat-option>&mdash;</mat-option>
        @for (status of checklistsService.consentStatuses$ | async; track status) {
          <mat-option
            [value]="status.id"
            >{{ status.status }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Task Status</mat-label>
      <mat-select [formControl]="taskFilters.controls.checklist_status_id">
        <mat-option>&mdash;</mat-option>
        @for (
          status of checklistsService.consentChecklistStatuses$ | async
          ; track
          status) {
          <mat-option
            [value]="status.id"
            >{{ status.checklist_status }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Responsible Party</mat-label>
      <input matInput [matAutocomplete]="auto" />
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="
          taskFilters.controls.responsible_party.setValue($event.option.value)
        ">
        @for (party of checklistsService.checklistParties$ | async; track party) {
          <mat-option
            [value]="party"
            >{{ party }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Due Date</mat-label>
      <input
        matInput
        [formControl]="taskFilters.controls.due_date"
        [matDatepicker]="duePicker" />
      <mat-datepicker-toggle
        matIconSuffix
      [for]="duePicker"></mat-datepicker-toggle>
      <mat-datepicker #duePicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="table-header">
    <div class="table-label">
      <h2>Tasks</h2>
    </div>
    <span class="pagination-container">
      @if (checklistsService.loading$ | async) {
        <mat-spinner
          class="consents-loading-spinner"
        ></mat-spinner>
      }
      <mat-paginator
        class="mat-paginator-sticky"
        [pageSize]="
          (checklistsService.consentChecklistTasks$ | async)?.paginatorInfo
            ?.perPage ?? 0
        "
        [hidePageSize]="true"
        [showFirstLastButtons]="true"
        [pageIndex]="
          ((checklistsService.consentChecklistTasks$ | async)?.paginatorInfo
            ?.currentPage ??
            1) -
          1
        "
        (page)="getPage($event.pageIndex + 1)"
        [length]="
          (checklistsService.consentChecklistTasks$ | async)?.paginatorInfo
            ?.total ?? 0
        "
      [disabled]="!!(checklistsService.loading$ | async)"></mat-paginator>
    </span>
  </div>
  <div class="table-container" #container>
    <table mat-table [dataSource]="data">
      <ng-container matColumnDef="approval">
        <th mat-header-cell *matHeaderCellDef=""></th>
        <td mat-cell *matCellDef="let item">
          <span class="indicators">
            <button
              mat-icon-button
              matTooltip="Checklist Tasks"
              (click)="openChecklistDialog(item.request_id)">
              <consent-checklist-indicator
              [indicatorState]="item.checklist"></consent-checklist-indicator>
            </button>
            <button
              mat-icon-button
              matTooltip="Investor Approvals"
              (click)="openApprovalDialog(item.request_id)">
              <consent-approval-indicator
              [indicatorState]="item.approval"></consent-approval-indicator>
            </button>
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="deal">
        <th mat-header-cell *matHeaderCellDef="">Deal</th>
        <td mat-cell *matCellDef="let item">
          <contact-link [subject]="item.deal"></contact-link>
          @if (item.sponsor) {
            <contact-link [subject]="item.sponsor"></contact-link>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="request">
        <th mat-header-cell *matHeaderCellDef="">Request</th>
        <td mat-cell *matCellDef="let item">{{ item.request }}</td>
      </ng-container>
      <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef="">Details</th>
        <td mat-cell *matCellDef="let item">{{ item.details }}</td>
      </ng-container>
      <ng-container matColumnDef="timing">
        <th mat-header-cell *matHeaderCellDef="">Timing</th>
        <td mat-cell *matCellDef="let item">
          <span class="timing-wrapper">
            <span class="timing-side">
              <span class="date">
                <mat-icon [class]="item.timing.is_urgent ? 'urgent' : ''">{{
                  item.timing.is_urgent ? "flag" : "outlined_flag"
                }}</mat-icon>
                @if (item.timing.due_date?.length) {
                  <span>{{
                    item.timing.due_date
                  }}</span>
                }
              </span>
              <span class="urgency-note">{{
                item.timing.urgency_comment
              }}</span>
            </span>
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="request_status">
        <th mat-header-cell *matHeaderCellDef="">Request Status</th>
        <td mat-cell *matCellDef="let item">{{ item.request_status }}</td>
      </ng-container>
      <ng-container matColumnDef="task">
        <th mat-header-cell *matHeaderCellDef="">Task</th>
        <td mat-cell *matCellDef="let item">{{ item.task }}</td>
      </ng-container>
      <ng-container matColumnDef="task_status">
        <th mat-header-cell *matHeaderCellDef="">Task Status</th>
        <td mat-cell *matCellDef="let item">{{ item.task_status }}</td>
      </ng-container>
      <ng-container matColumnDef="due_date">
        <th mat-header-cell *matHeaderCellDef="">Due Date</th>
        <td mat-cell *matCellDef="let item">{{ item.due_date }}</td>
      </ng-container>
      <ng-container matColumnDef="started_date">
        <th mat-header-cell *matHeaderCellDef="">Started Date</th>
        <td mat-cell *matCellDef="let item">{{ item.started_date }}</td>
      </ng-container>
      <ng-container matColumnDef="responsible_party">
        <th mat-header-cell *matHeaderCellDef="">Responsible Party</th>
        <td mat-cell *matCellDef="let item">
          @if (item.responsible_party.__typename) {
            <contact-link
            [subject]="item.responsible_party"></contact-link>
          } @else {
            {{ item.responsible_party }}
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef="">Notes</th>
        <td mat-cell *matCellDef="let item">{{ item.notes }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: columns"
        [class]="{
          alert: row.pastDue
        }"></tr>
    </table>
  </div>
</div>
